module.exports = __webpack_public_path__ + "static/media/1006094.7f0ff24d.png";